module.exports = __webpack_public_path__ + "img/mastercard.841217a4.jpg";